import { Component, OnInit } from '@angular/core';

import { tap } from 'rxjs/operators';

import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { PopupService } from './popup.service';


interface Mensagem {
  mensagem: string;
  titulo: string;
  tipo: string;
}

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  public displayModal = false;
  public mensagem: Mensagem;

  constructor(
    private readonly autenticacaoService: AutenticacaoService,
    private readonly popupService: PopupService,
  ) { }

  ngOnInit() {
    if (this.popupService.control) {
      return;
    }

    this.popupService.getAlvo(this.autenticacaoService.usuarioLogado.username).pipe(
      tap(response => {
        if (response) {
          this.popupService.getMensagem().pipe(
            tap(mensagem => {
              this.mensagem = mensagem;
              this.popupService.control = true;
              this.displayModal = true;
            })
          ).subscribe();
        }
      })
    ).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popup/popup.component.ts